import { tracking, _t } from '@bark/bark-core';

export function SellerDashboardProspectRescueFlow() {
    const Bark = (window.Bark = window.Bark || {});
    const seller = Bark.seller = Bark.seller || {};

    const colorModal = (modal, setToDesignSystemColors = true) => {
        const backgroundColor = setToDesignSystemColors ? 'rgb(17, 22, 55)' : 'rgba(22,25,41,.3)';

        try {
            $(modal.data('bs.modal')._backdrop).css({ backgroundColor })
        } catch (e) {}
    };

    /**
     * @param {string|null} label
     */
    const showLoading = (label= null) => {
        const spinner = $('#design-system-loading-spinner');
        $('.js-design-system-loading-spinner-text').text(label || _t("common:please-wait-message"));

        spinner.modal('show');

        colorModal(spinner);
    };

    const hideLoading = () => {
        const spinner = $('#design-system-loading-spinner');
        spinner.modal('hide');

        colorModal(spinner, false);
    };

    const testIsLeadAvailable = async (projectId) => {
        const payload = {
            is_prospect_response: 1,
            project_id: projectId,
            results_per_request: 1
        };

        let leadFound = false;

        try {
            const response = await Bark.api(Bark.seller.getDataUrl(), payload, null, null, 'GET', {
                Accept: 'application/vnd.bark.v2+json',
            });

            // Need to do a forEach as, although we've said results_per_request = 1, the API endpoint will return +1
            response.data.items.forEach((/** ProjectObject */ project) => {
                if (Number(project.project_id) === Number(projectId)) {
                    leadFound = true;
                }
            });
        } catch (e) {
            console.error(e);
            tracking('prospect-response-rescue-flow', 'failed to test if lead was available', {
                seller_profile_id: Bark.seller.id,
                project_id: projectId,
            });
        }

        return leadFound;
    };

    const handleLeadUnavailable = () => {
        const modal = $('#prospect-rescue-failed-modal');
        const title = Bark.ProjectsData?.projectToRespondName ?
            _t('seller_dashboard:prospect-rescue-flow.already-responded-name', {buyerName: Bark.ProjectsData.projectToRespondName }) :
            _t('seller_dashboard:prospect-rescue-flow.already-responded');

        $('.js-title', modal).text(title);

        hideLoading();

        modal.modal('show').on('hidden.bs.modal', () => {
            colorModal(modal, false);
        });

        colorModal(modal);
    };

    const forceRespondToLead = async (projectId) => {
        const campaign = $('#session-campaign').val() || Bark.seller.getUrlParameter('campaign');
        const responded = await seller.submitYourDetailsApi(
            projectId,
            campaign,
            false
        );

        if (responded) {
            tracking('prospect-response-rescue-flow', 'navigating to responses', {
                seller_profile_id: Bark.seller.id,
                project_id: projectId,
            });
            document.location = `/sellers/my-barks/?prx=${projectId}`;
        } else {
            handleLeadUnavailable();
        }
    };

    /**
     * @param {int} projectId
     */
    seller.initProspectResponseFlow = async (projectId) => {
        tracking('prospect-response-rescue-flow', 'init', {
            seller_profile_id: Bark.seller.id,
            project_id: projectId,
        });

        showLoading(_t('seller_dashboard:prospect-rescue-flow.finding-lead'));

        const isLeadAvailable = await testIsLeadAvailable(projectId);

        if (!isLeadAvailable) {
            handleLeadUnavailable();
            return;
        }

        showLoading(_t('seller_dashboard:prospect-rescue-flow.redirecting-lead'));

        forceRespondToLead(projectId);
    };
}
